module.exports = __webpack_public_path__ + "img/live-cover.ef993d98.png";